import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import Section from '../../components/layout/Section';
import CartList from '../../components/UI/CartList';
import MainBody from '../../components/layout/MainBody';
import { Medium } from '../../components/UI/Text';

import { FONT } from '../../styles/color';
import Calculator from '../../components/UI/Calculator';
import PageTitle from '../../components/UI/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { cartApi } from '../../api/cart';
import { SHIPPING_FEE } from '../../utils/constants';

const CartContainer = styled.div`
	width: 90%;
	max-width: 1320px;
    display: flex;
    flex-direction: row;
    gap: 50px;
    margin-bottom: 100px;

	@media (max-width: 1080px) {
		flex-direction: column;
		align-items: stretch;
		gap: 30px;
	}
`;

const LeftSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-width: 480px;
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;

    @media (max-width: 1080px) {
		width: 100%;
	}
`;

const AllSelectWrapper = styled.div`
    padding: 15px 0;
    border-bottom: 2px solid ${ FONT.mid };
`;

const RightSection = styled.div`
    width: 370px;
    height: fit-content;
    position: sticky;
    top: 324px;
    right: 0px;
    flex-shrink: 0;

    @media (max-width: 1080px) {
		position: relative;
        top: auto;
        right: auto;
        width: 100%;
	}
`;

// TODO: 선택 항목 삭제 추가
export default function Cart() {
    const navigate = useNavigate();
    const {data, loading, error} = useFetch(cartApi.getCartItems, []);
	
    const [items, setItems] = React.useState([]);
    const [selectedItems, setSelectedItems] = React.useState(new Array(items.length).fill(false));
    const [isDeleted, setIsDeleted] = React.useState(new Array(items.length).fill(false));
    const itemsRef = React.useRef(items);

    // 데이터 초기 로드 시
    useEffect(() => {
        if (data && Array.isArray(data)) {
            setItems(data);
            setSelectedItems(new Array(data.length).fill(true));
            setIsDeleted(new Array(data.length).fill(false));
        }
    }, [data]);
    
    useEffect(() => {
        itemsRef.current = items;
    }, [items]);

    // 언마운트 시 장바구니 정보 저장
    useEffect(() => {
        return () => {
            cartApi.updateCartItem(itemsRef.current);
        }
    }, []);
    
    if(loading) {
        return ;
    }

    if(error) {
        alert('장바구니 정보를 불러오는 도중에 오류가 발생했습니다.');
        navigate('/');
        return ;
    }
    
    const allSelected = items.length > 0 && items.every((item, index) => selectedItems[index]);

    const handleSelectAll = (checked) => {
        const newSelectedItems = {};
        items.forEach((item, index) => {
            newSelectedItems[index] = checked;
        });
        setSelectedItems(newSelectedItems);
    };

    const handleToggleSelect = (itemIndex, isSelected) => {
        setSelectedItems(prev => ({
            ...prev,
            [itemIndex]: isSelected
        }));
    };

    const handleQuantityChange = (itemIndex, newQuantity) => {
        setItems( prev => 
            prev.map((item, index) =>
                index === itemIndex ?
                    { ...item, quantity: newQuantity }
                    : item
            )
        ); 
    };

    const onClickOrder = () => {
        const orderItems = items.reduce((acc, item, index) => {
            if(selectedItems[index]) {
                acc.push({ ...item, shippingFee: SHIPPING_FEE });
            }
            return acc;
        }, []);

        console.log(orderItems);
        
        if(orderItems.length === 0) {
            alert('주문할 상품을 선택해주세요.');
            return;
        }

        // 주문 내역은 quantity 0으로 변경
        setItems(prev => 
            prev.map((item, index) =>
                selectedItems[index] ?
                    { ...item, quantity: 0 }
                    : item
            )
        );
        
        navigate('/order', { state: { orderItems } });
    }

    return (
        <MainBody>
            <Section>
                <CartContainer>
                    <LeftSection>
                        <PageTitle>장바구니</PageTitle>
                        <AllSelectWrapper>
                            <Medium size="16px">
                                <input type="checkbox" checked={ allSelected } onChange={e => handleSelectAll(e.target.checked)} />&nbsp;전체선택 ({ items.length })
                            </Medium>
                        </AllSelectWrapper>
                        <CartList
                            $useCheckbox={ true }
                            items={ items }
                            selectedItems={ selectedItems } onToggleSelect={ handleToggleSelect }
                            onQuantityChange={ handleQuantityChange }
                        />
                    </LeftSection>
                    <RightSection>
                        <Calculator
                            title="주문 예상 금액"
                            items={ items }
                            selectedItems={ selectedItems }
                            onClickOrder= {onClickOrder}
                        />
                    </RightSection>
                </CartContainer>
            </Section>
        </MainBody>
    );
}